if (!customElements.get('accordion-component')) {
  customElements.define(
    'accordion-component',
    class Accordion extends HTMLElement {
      constructor() {
        super();
        this.accordionToggle = this.querySelector('[accordion-toggle]');
        this.accordionBody = this.querySelector('[accordion-body]');
        if (!this.accordionToggle || !this.accordionBody) return;
        this.setInitialHeight();
        this.toggleAccordion();
      }

      toggleAccordion() {
        this.accordionToggle.addEventListener('click', () => {
          this.toggleAttribute('open');
          const scrollHeight = this.accordionBody.scrollHeight;
          this.accordionBody.style.height = this.hasAttribute('open') ? `${scrollHeight}px` : '0px';
        });
      }

      setInitialHeight() {
        const initialHeight = this.accordionBody.clientHeight;
        this.accordionBody.style.height = `${initialHeight}px`;
      }
    }
  );
}
